import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetHistoryBonusGetById = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_USER_HISTORY_BONUSES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetHistoryBonusGetByIdAction({
                    data: data.data,
                    count: data.count
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetHistoryBonusGetById as SetGetHistoryBonusGetById
}